export const defaultMaxImageBytes = Math.floor(37.5 * 1000000 * (3 / 4));
